<template>
  <div class="header">
    <a :href="titleInfo.clickpath">
      <img :src="titleInfo.logourl"
           style="position: absolute;left: 200px;top: 7px">
    </a>


    <el-menu class="el-menu-demo cloud-menu" mode="horizontal" text-color="#4c5159" active-text-color="#1f8eeb">
      <el-menu-item index="1">
        <router-link to="/index">
          首页
        </router-link>
      </el-menu-item>

      <el-menu-item index="2">
        <router-link to="/news">
          资讯中心
        </router-link>
      </el-menu-item>

      <el-submenu index="5"   :popper-append-to-body="false">
        <template slot="title">我们的服务</template>
        <a href="" style="width: 100px !important;">
          <el-menu-item index="5-1" class="changeItem">
            <router-link to="/align">
              计量校准
            </router-link>

          </el-menu-item>
          <el-menu-item index="5-2" class="changeItem">
            <router-link to="/consult">
              验证咨询
            </router-link>

          </el-menu-item>

        </a>

      </el-submenu>
      <el-menu-item index="4">
      <a href="https://www.zjhylab.com/passport/"  target="_blank" >智慧验证</a>
      </el-menu-item>

      <el-menu-item index="5">
        <router-link to="/aboutus">
          走进华验
        </router-link>
      </el-menu-item>

    </el-menu>


    <!--<a href="https://www.hzjly.cn/login.aspx">-->
    <!--<el-button class="header-btn float-right">返回旧版</el-button>-->
    <!--</a>-->


  </div>



</template>

<script>
  export default {
    name: "vheader",
    data() {
      return {
          titleInfo:{
              logourl:'',
              clickpath:'',
          },
      }
    },
    mounted() {
			this.getInfo();
    },
    methods: {

        getInfo(){
            this.$axios.get("https://www.zjhylab.com/api/GlobalConfig/GetLogo_Info", {
                params: {

                }
            })
            .then(res => {
                var data = JSON.parse(res.data);
                console.log(data);
                this.titleInfo=data.results.result.logoandphone_info;

            })
            .catch(err => {

            });
        }  ,
    }
  }
</script>

<style scoped>

  .header {
    height: 100%;
    line-height: 60px;
    background-color: white;
    color: black;


  }

  .header-btn {
    margin-left: 10px;
    margin-top: 10px;
    background-color: transparent;
    color: #bfbfbf;
    border-radius: 2px;
    padding: 8px 22px
  }

  .header-btn:hover {
    border: 1px #4aa8f6 solid;
    color: #4aa8f6;
  }

  .header ul li {
    padding: 0 20px;
    margin: 0;
  }

  .header ul li:hover {
    cursor: pointer;
    color: #4aa8f6;
    /*border-bottom: 2px #4aa8f6 solid;*/
  }

  .cloud-menu {
    color: #4c5159;
    position: absolute;
    right: 130px;
    background-color: transparent;

    height: 60px
  }
>>> .el-submenu__icon-arrow.el-icon-arrow-down{
  display: none;
}
>>>.el-menu-item a{
  position: relative;top: -2px
}
 >>> .el-submenu__title{
      padding: 0px;
  }
  >>> .el-menu-item {
    font-size: 18px;
    display: block !important;
  }
  >>> .el-menu-item:hover {

  }
 >>> .el-submenu {

    display: block !important;
  }
  >>> .el-submenu__title{
    font-size: 18px;
  }
  .changeItem{
    height: 34px !important;
    font-size: 14px;
    /*color: #999999 !important;*/
    width: 110px;
    min-width: 110px;
    text-align: center !important;
  }
  .changeItem:hover{
    color: #247af0 !important;
  }
  >>>.el-menu.el-menu--popup.el-menu--popup-bottom-start{
    padding: 8px;
      min-width: 110px;
    width: 110px;
  }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue